import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

export interface AccountCustommer {
  /** TODO: Fill with attributes */
  placeholder: string;
}
export default class AccountCustomerService {
  private httpClient = makeHttpClient();
  getAll(customer_id: any) {
    let url = `${env.customerUrl}account/?`;
    if (customer_id != null) {
      url = `${url}customer_id=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }
}
